var exports = {
  "Pf": "AvatarUploader.module__label___Wjg2Y3",
  "GC": "AvatarUploader.module__buttonGroup___Wjg2Y3",
  "Ng": "AvatarUploader.module__buttonGroupAfterMode___Wjg2Y3",
  "gJ": "AvatarUploader.module__errorMessage___Wjg2Y3",
  "lB": "AvatarUploader.module__spacedParagraph___Wjg2Y3",
};

module.exports = exports;
